import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import AsyncSelect from "../../../components/elements/inputs/AsyncSelect";
import useDownloadReports from "../../../hooks/sales/reports/useDownloadReports";
import { Button } from "@mui/material";
import Pagination from "../../../components/elements/pagination";

const SalesReports = () => {
  const {
    brandOptions,
    brandHasMore,
    fetchBrands,
    brandQuery,
    brandId,
    handleBrandSelect,
    // Date states
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    // Download function
    downloadReports,
    // Fetch reports
    fetchReports,
    reports,
    isReportListLoading,
    enableFetchQuery,
    pagination,
    handlePageClick,
  } = useDownloadReports();

  const pageCount =
    pagination?.total_count && pagination?.per_page
      ? Math.ceil(pagination?.total_count / pagination?.per_page)
      : 0;

  return (
    <div>
      <div className="reports__head headingBorder__b">
        <h2 className="titleHeading">Sales Reports</h2>
      </div>

      <div className="flex mt-10 items-end gap-5 px-5 md:px-10 flex-wrap">
        <div className="w-40">
          <label className="mb-2 block">From date:</label>
          <ReactDatePicker
            dateFormat="dd/MM/yyyy"
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            className="input w-full"
          />
        </div>
        <div className="w-40">
          <label className="mb-2 block">To date:</label>
          <ReactDatePicker
            dateFormat="dd/MM/yyyy"
            selected={toDate}
            onChange={(date) => setToDate(date)}
            className="input w-full"
          />
        </div>
        <div>
          <label className="mb-2 block">Brand:</label>
          <AsyncSelect
            options={brandOptions}
            hasMore={brandHasMore}
            fetchNext={fetchBrands}
            isLoading={brandQuery?.isFetching}
            value={brandId}
            onChange={handleBrandSelect}
          />
        </div>
        <div className="mb-1">
          <Button
            variant="outlined"
            className="primaryBtn-outlined"
            onClick={fetchReports}
          >
            Fetch Reports
          </Button>
        </div>

        <div className="mb-1">
          <Button
            variant="contained"
            className="primaryBtn-solid"
            onClick={downloadReports}
          >
            Download Reports
          </Button>
        </div>
      </div>

      <div className="px-5 mb-10">
        {enableFetchQuery && isReportListLoading ? (
          <p className="w-full text-center py-20">Loading reports...</p>
        ) : (
          <>
            {enableFetchQuery && reports.length === 0 && (
              <p className="w-full text-center py-20">
                No reports found for the selected criteria.
              </p>
            )}
            {reports.length > 0 && (
              <>
                <div className="overflow-auto">
                  <table className="mt-10 mb-5 px-5 border-collapse table-auto w-full whitespace-no-wrap bg-white table-striped relative">
                    <thead>
                      <tr className="w-full">
                        <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                          Customer Name
                        </th>
                        <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                          <p className="w-36">Payment date</p>
                        </th>
                        <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                          Payment method
                        </th>
                        <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                          <p className="w-40">Product details</p>
                        </th>
                        <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                          <p className="w-40">Shipping address</p>
                        </th>
                        <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                          <p className="w-40">Billing address</p>
                        </th>
                        <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                          Total amount
                        </th>
                        <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                          <p className="w-36">Invoice number</p>
                        </th>
                        {/* <th className="bg-gray-100 sticky top-0 border-b border-gray-200 px-6 py-2 text-gray-600 font-bold tracking-wider uppercase text-xs">
                          <p className="w-36">Transaction ID</p>
                        </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {reports?.map((report, index) => {
                        return (
                          <tr key={index} className="border-b border-gray-200">
                            <td className="px-6 py-4 text-sm text-gray-700">
                              {report.customer_name || "N/A"}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-700">
                              {report.payment_date || "N/A"}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-700">
                              {report.payment_method || "N/A"}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-700">
                              {report.product_details || "N/A"}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-700">
                              {report.shipping_address || "N/A"}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-700">
                              {report.billing_address || "N/A"}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-700">
                              {report.total_amount || "N/A"}
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-700">
                              {report.invoice_no || "N/A"}
                            </td>
                            {/* <td className="px-6 py-4 text-sm text-gray-700">
                              {report.transaction_id || "N/A"}
                            </td> */}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <Pagination
                  currentPage={pagination?.page_no}
                  lengthofItems={pagination?.total_count}
                  limit={pagination?.per_page}
                  pageCount={pageCount}
                  onPageChange={handlePageClick}
                />
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SalesReports;
